export default __webpack_public_path__ + "static/media/warning--crossroads--g3.522ca193.png";